import { jsx as r } from "react/jsx-runtime";
import { GuidanceIcon as s } from "./index.es5667.js";
import { ErrorIcon as c } from "./index.es5668.js";
import { SuccessIcon as o } from "./index.es5669.js";
const a = {
  success: /* @__PURE__ */ r(o, { state: "success" }),
  error: /* @__PURE__ */ r(c, { state: "error" }),
  guidance: /* @__PURE__ */ r(s, { state: "guidance" })
}, i = {
  success: "success",
  error: "error",
  guidance: "gray"
};
export {
  a as STATE_TO_ICON,
  i as STATE_TO_TEXT_COLOR
};
//# sourceMappingURL=index.es5605.js.map
